import { configureStore, isRejected, createListenerMiddleware} from '@reduxjs/toolkit';
import { createLogger as createReduxLogger } from 'redux-logger';
import createReducer from './rootReducer';
import SubscriptionManager from './SubscriptionManager';
import crashReporter from 'app/shared-components/error/crashReporter';
import loginStatusChecker from './loginStatusChecker';
import { logoutUser } from 'app/store/userSlice';
import { signOut } from 'aws-amplify/auth';

// Reducer hot-reload was a CRA/webpack-only nicety (`module.hot.accept(...)`).
// Vite's React Fast Refresh handles component HMR; if reducer-level HMR is
// wanted back, re-add via `import.meta.hot.accept('./rootReducer', ...)`.

const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  matcher: isRejected,
  effect: async (action, {state, dispatch}) => {
    if (action.error?.name == "SecurityError" || action.error?.message == "Unauthorized"){
       dispatch(logoutUser());
       signOut({ global: true });
    }
  },
})

const middlewares = [loginStatusChecker, crashReporter, listenerMiddleware.middleware];

if (process.env.NODE_ENV === 'development') {
  // Vite tree-shakes the import out of prod builds because NODE_ENV is
  // inlined as a literal string and the branch becomes unreachable.
  middlewares.push(
    createReduxLogger({ collapsed: (getState, action, logEntry) => !logEntry.error })
  );
}

const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: {
        extraArgument: SubscriptionManager,
      },
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === 'development',
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(createReducer(store.asyncReducers));
  return store;
};

export default store;
